import React from "react";

function DepthIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="21"
      viewBox="0 0 27 21"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero" transform="translate(9 6)">
          <path d="M5 14l.297-11.182 2.411 2.434c.22.22.576.22.796 0l.331-.332a.562.562 0 000-.795L4.898.165a.563.563 0 00-.796 0L.165 4.125a.562.562 0 000 .795l.331.332c.22.22.576.22.796 0l2.411-2.434L4 14c-.52-.146-.854-.146-1 0-.146.146.52.146 2 0z"></path>
        </g>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M4.528 1.5L22.472 1.5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M1.521 19.5L25.479 19.5"
        ></path>
        <path
          stroke="currentColor"
          strokeDasharray="2"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M4.5 1.5L1.5 20.5"
        ></path>
        <path
          stroke="currentColor"
          strokeDasharray="2"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M25.5 1.5L22.5 20.5"
          transform="matrix(-1 0 0 1 48 0)"
        ></path>
      </g>
    </svg>
  );
}

export default DepthIcon;
